import { render, staticRenderFns } from "./gapErrors.vue?vue&type=template&id=977c2f8c&scoped=true"
import script from "./gapErrors.vue?vue&type=script&lang=js"
export * from "./gapErrors.vue?vue&type=script&lang=js"
import style0 from "./gapErrors.vue?vue&type=style&index=0&id=977c2f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977c2f8c",
  null
  
)

export default component.exports